import type { Color } from 'src/types/theme';

export const secondary: Color = {
  50: '#ffffff',
  100: '#ffffff',
  200: '#ffffff',
  300: '#ffffff',
  400: '#ffffff',
  500: '#cacaca',
  600: '#cacaca',
  700: '#cacaca',
  800: '#ababab',
  900: '#ababab',
};
